// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.schedule-filter-bar {
  color: black;
  font-size: 14px;
  height: 100%;
}
.schedule-filter-bar ::-webkit-scrollbar {
  height: 0px;
}
.schedule-filter-bar .schedule-filter-slide {
  display: flex;
  align-items: center;
  position: absolute;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: var(--bottom-bar-color);
  /** Animate bar sliding in **/
  bottom: -100%;
  animation: slideIn 400ms;
  animation-fill-mode: forwards;
}
@keyframes slideIn {
  0% {
    bottom: -100%;
  }
  100% {
    bottom: 0;
  }
}
.schedule-filter-bar .schedule-icon-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 20px;
  margin-left: 20px;
  cursor: pointer;
}
.schedule-filter-bar .schedule-icon-col svg-icon {
  font-size: 20px;
}
.schedule-filter-bar .filter-list {
  display: flex;
  flex-direction: row;
  height: 100%;
  padding: 10px;
  overflow-x: auto;
  padding-top: 18px;
  padding-bottom: 18px;
  box-sizing: border-box;
}
.schedule-filter-bar .event-filter {
  width: 100px;
  position: relative;
  display: flex;
  margin-right: 14px;
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow);
  background-color: white;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  padding: 2px 30px;
  cursor: pointer;
}
.schedule-filter-bar .event-filter .filter-count {
  border-radius: 9px;
  padding: 2px 6px;
  color: #222;
  background-color: white;
  box-shadow: 0 0 5px rgba(20, 20, 20, 0.3);
  position: absolute;
  right: -9px;
  bottom: -8px;
  overflow: hidden;
}
.schedule-filter-bar .event-filter .event-icon {
  font-size: 11px;
  vertical-align: middle;
  line-height: 13px;
}
.schedule-filter-bar .filter-status-popup {
  display: flex;
  position: absolute;
  width: 100%;
  min-width: 200px;
  align-items: center;
  left: 0;
  width: 100%;
  bottom: -100%;
  margin-bottom: 10px;
  pointer-events: none;
  opacity: 0;
}
.schedule-filter-bar .filter-status-popup .filter-status {
  display: flex;
  color: white;
  width: 50%;
  min-width: 200px;
  pointer-events: initial;
  background-color: rgba(0, 0, 0, 0.418);
  justify-content: center;
  margin: auto;
  border-radius: var(--border-radius);
  padding: 10px;
  box-sizing: border-box;
}
@keyframes statusSlideOut {
  0% {
    opacity: 1;
    bottom: 100%;
  }
  100% {
    opacity: 0;
    bottom: 100%;
  }
}
@keyframes statusSlideIn {
  0% {
    opacity: 0;
    bottom: 50%;
  }
  40% {
    opacity: 1;
  }
  100% {
    opacity: 1;
    bottom: 100%;
  }
}
.schedule-filter-bar .filter-status-popup.shown {
  animation: statusSlideIn 400ms;
  animation-fill-mode: forwards;
}
.schedule-filter-bar .filter-status-popup.hidden {
  animation: statusSlideOut 900ms;
  animation-fill-mode: forwards;
}
.schedule-filter-bar .filter-enabled {
  background-color: var(--motes-blue);
  color: white;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/schedule-filter/schedule-filter.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,eAAA;EACA,YAAA;AACJ;AACI;EACI,WAAA;AACR;AAEI;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,yCAAA;EACA,6BAAA;EACA,aAAA;EACA,wBAAA;EACA,6BAAA;AAAR;AAGI;EACI;IACI,aAAA;EADV;EAGM;IACI,SAAA;EADV;AACF;AAII;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAFR;AAIQ;EACI,eAAA;AAFZ;AAMI;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;AAJR;AAOI;EACI,YAAA;EACA,kBAAA;EAEA,aAAA;EACA,kBAAA;EACA,mCAAA;EACA,6BAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EAGA,iBAAA;EACA,eAAA;AARR;AAUQ;EAEI,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,uBAAA;EACA,yCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AATZ;AAYQ;EACI,eAAA;EACA,sBAAA;EACA,iBAAA;AAVZ;AAcI;EACI,aAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,UAAA;AAZR;AAeQ;EACI,aAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,uBAAA;EACA,sCAAA;EACA,uBAAA;EACA,YAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;AAbZ;AAkBI;EACI;IACI,UAAA;IACA,YAAA;EAhBV;EAkBM;IACI,UAAA;IACA,YAAA;EAhBV;AACF;AAmBI;EACI;IACI,UAAA;IACA,WAAA;EAjBV;EAmBM;IACI,UAAA;EAjBV;EAmBM;IACI,UAAA;IACA,YAAA;EAjBV;AACF;AAoBI;EACI,8BAAA;EACA,6BAAA;AAlBR;AAqBI;EACI,+BAAA;EACA,6BAAA;AAnBR;AAsBI;EACI,mCAAA;EACA,YAAA;AApBR","sourcesContent":[".schedule-filter-bar {\n    color: black;\n    font-size: 14px;\n    height: 100%;\n\n    ::-webkit-scrollbar {\n        height: 0px;\n    }\n    \n    .schedule-filter-slide {\n        display: flex;\n        align-items: center;\n        position: absolute;\n        left: 0;\n        height: 100%;\n        width: 100%;\n        background-color: var(--bottom-bar-color);\n        /** Animate bar sliding in **/\n        bottom: -100%;\n        animation: slideIn 400ms;\n        animation-fill-mode: forwards;\n    }\n\n    @keyframes slideIn {\n        0% {\n            bottom: -100%;\n        }\n        100% {\n            bottom: 0;\n        }\n    }\n\n    .schedule-icon-col {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        margin-right: 20px;\n        margin-left: 20px;\n        cursor: pointer;\n\n        svg-icon {\n            font-size: 20px;\n        }\n    }\n\n    .filter-list {\n        display: flex;\n        flex-direction: row;\n        height: 100%;\n        padding: 10px;\n        overflow-x: auto;\n        padding-top: 18px;\n        padding-bottom: 18px;\n        box-sizing: border-box;\n    }\n\n    .event-filter {\n        width: 100px;\n        position: relative;\n        // height: 80%;\n        display: flex;\n        margin-right: 14px;\n        border-radius: var(--border-radius);\n        box-shadow: var(--box-shadow);\n        background-color: white;\n        align-items: center;\n        justify-content: center;\n        white-space: nowrap;\n        // padding-top: 8px;\n        // padding-bottom: 8px;\n        padding: 2px 30px;\n        cursor: pointer;\n\n        .filter-count {\n            // border: 1px solid rgb(184, 184, 184);\n            border-radius: 9px;\n            padding: 2px 6px;\n            color: #222;\n            background-color: white;\n            box-shadow: 0 0 5px rgb(20 20 20 / 30%);\n            position: absolute;\n            right: -9px;\n            bottom: -8px;\n            overflow: hidden;\n        }\n\n        .event-icon {\n            font-size: 11px;\n            vertical-align: middle;\n            line-height: 13px;\n        }\n    }\n\n    .filter-status-popup {\n        display: flex;\n        position: absolute;\n        width: 100%;\n        min-width: 200px;\n        align-items: center;\n        left: 0;\n        width: 100%;\n        bottom: -100%;\n        margin-bottom: 10px;\n        pointer-events: none;\n        opacity: 0;\n\n\n        .filter-status {\n            display: flex;\n            color: white;\n            width: 50%;\n            min-width: 200px;\n            pointer-events: initial;\n            background-color: rgba(0, 0, 0, 0.418);\n            justify-content: center;\n            margin: auto;\n            border-radius: var(--border-radius);\n            padding: 10px;\n            box-sizing: border-box;\n        }\n    }\n\n\n    @keyframes statusSlideOut {\n        0% {\n            opacity: 1;\n            bottom: 100%;\n        }\n        100% {\n            opacity: 0;\n            bottom: 100%;\n        }\n    }\n\n    @keyframes statusSlideIn {\n        0% {\n            opacity: 0;\n            bottom: 50%;\n        }\n        40% {\n            opacity: 1;\n        }\n        100% {\n            opacity: 1;\n            bottom: 100%;\n        }\n    }\n\n    .filter-status-popup.shown {\n        animation: statusSlideIn 400ms;\n        animation-fill-mode: forwards;\n    }\n\n    .filter-status-popup.hidden {\n        animation: statusSlideOut 900ms;\n        animation-fill-mode: forwards;\n    }\n\n    .filter-enabled {\n        background-color: var(--motes-blue);\n        color: white;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
